// Language resolution shared by i18n bootstrap and the canonical-language
// guard. Visitors without a saved preference get the best match for their
// Accept-Language (navigator.languages is its client-side mirror), English
// when none of the supported languages match.
export const SUPPORTED_LANGS = ["it", "en", "de", "fr", "es", "pl"];
export const LANG_PREF_KEY = "mtt_lang";
const FALLBACK = "en";

const CRAWLER_RE = /bot|crawl|spider|slurp|bingpreview|duckduck|yandex|baidu|ahrefs|semrush|lighthouse|headlesschrome/i;

const normalize = (v) => {
  const code = String(v || "").toLowerCase().slice(0, 2);
  return SUPPORTED_LANGS.includes(code) ? code : null;
};

/** Search engines must keep seeing Italian on the canonical root URL. */
export function isCrawler() {
  if (typeof navigator === "undefined") return true;
  return CRAWLER_RE.test(navigator.userAgent || "");
}

export function savedLang() {
  try {
    return normalize(localStorage.getItem(LANG_PREF_KEY));
  } catch {
    return null;
  }
}

export function browserLang() {
  if (typeof navigator === "undefined") return null;
  const list = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const entry of list) {
    const code = normalize(entry);
    if (code) return code;
  }
  return null;
}

export function initialLang() {
  let qs = null;
  try {
    qs = normalize(new URLSearchParams(window.location.search).get("lang"));
  } catch { /* no window */ }
  if (qs) return qs;
  const saved = savedLang();
  if (saved) return saved;
  if (isCrawler()) return "it";
  return browserLang() || FALLBACK;
}

/** Best-effort country for anonymous sessions: region tag of the browser
 *  locale (it-IT → IT). Replaced by the real profile country after login. */
export function countryHint() {
  if (typeof navigator === "undefined") return null;
  const list = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const entry of list) {
    const region = String(entry || "").split("-")[1];
    if (region && /^[A-Za-z]{2}$/.test(region)) return region.toUpperCase();
  }
  return null;
}
